/**
 * GraphQL schema definition that describes the server schema.
 * This does not include any part of the client schema.
 *
 * Schema definitions are composable.
 * To convert a schema definition into a schema, use `buildAstFromSchema`.
 */
import GraphQLServerSchemaDef from '../../../graphql-schema.graphql';
export default GraphQLServerSchemaDef;
